import { dbOps, type DBOpsState } from "../hooks/dbOps.store";

export type ExposedDBOpsOnProcessState = Pick<
  DBOpsState,
  | "getMegaJSONDef"
  | "getProcessDef"
  | "getProcess"
  | "getProcessByTag"
  | "getSwimlane"
  | "getSwimlanes"
  | "getSwimlaneByTag"
  | "getSwimlaneByStepId"
  | "getStep"
  | "getSteps"
  | "getStepByTag"
  | "getStepByFieldId"
  | "getField"
  | "getFields"
  | "getFieldByTag"
  | "getRule"
  | "getRules"
  | "getConditionGroup"
  | "getConditionGroups"
  | "getCondition"
  | "getConditions"
  | "getBulkAction"
  | "getBulkActions"
  | "getComponentByTag"
  | "getComponent"
  | "getMetaJSONLookUpComponent"
  | "getMegaJSONLookup"
  | "getMetaJSONLookup"
  | "getConditionsOfProcess"
  | "getConditionGroupsOfProcess"
  | "getFieldsOfProcess"
  | "getStepsOfProcess"
  | "getSwimlanesOfProcess"
  | "getOnCreateWorkflow"
  | "getEventRule"
  | "getEventRules"
  | "getStateRule"
  | "getStateRules"
>;

export type ExposedDBOpsState = ExposedDBOpsOnProcessState &
  Pick<
    DBOpsState,
    // App Settings
    | "getAppSettings"
    | "getAppSettingsRaw"
    | "getUserGroups"
    | "getRegions"
    | "getProcessKinds"
    | "getProcessStatuses"
    | "getObjectStatuses"
    | "getProcessPDFTemplates"
    | "getAlertCategories"
    | "getCommentFlagOptions"
    | "getEmailTemplates"
    | "getEmailAttachments"
    | "getBusinessUnits"
    | "getObjectTypeWorkflowKindRelations"
    | "getExtraJSONs"
    | "getUserGroup"
    | "getRegion"
    | "getProcessKind"
    | "getProcessStatus"
    | "getObjectStatus"
    | "getProcessPDFTemplate"
    | "getAlertCategory"
    | "getCommentFlagOption"
    | "getEmailTemplate"
    | "getEmailAttachment"
    | "getObjectTypeWorkflowKindRelation"
    | "getExtraJSON"
    | "getBusinessUnit"
    | "getIntegrationToken"
    | "getIntegrationTokens"
    | "getIntegrationConfig"
    | "getIntegrationConfigs"
    | "bulkSetIntegrationTokens"
    | "bulkSetIntegrationConfigs"
    // other
    | "setIsEditModeEnabled"
    | "stateManager"
    | "initialize"
    | "deConstructor"
    | "clearChangesForApp"
    | "clearUndoStack"
    | "clearRedoStack"
    | "getDataObjects"
    | "getDataObject"
  >;

export const studioState: () => ExposedDBOpsState = dbOps;
